import React from "react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import PublicEstimateView from "@/pages/PublicEstimateView";
import PublicInvoiceView from "@/pages/PublicInvoiceView";
import { Toaster } from "sonner";
import "@/App.css";

function Gate() {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        <div className="font-mono-tech text-sm text-[var(--text-secondary)] animate-pulse">
          LOADING…
        </div>
      </div>
    );
  }

  if (!user) return <LoginPage />;
  return <Dashboard />;
}

export default function App() {
  // Vista pública de Estimate compartido (Feb 2026): si la URL trae
  // `?e=<share_token>`, se muestra el documento SIN login ni AuthProvider.
  const shareToken = new URLSearchParams(window.location.search).get("e");
  if (shareToken) {
    return (
      <div className="App">
        <PublicEstimateView token={shareToken} />
      </div>
    );
  }
  // Vista pública de Invoice compartido: mismo patrón con `?i=<share_token>`.
  const invoiceToken = new URLSearchParams(window.location.search).get("i");
  if (invoiceToken) {
    return (
      <div className="App">
        <PublicInvoiceView token={invoiceToken} />
      </div>
    );
  }
  return (
    <I18nProvider>
      <AuthProvider>
        <div className="App">
          <Gate />
          <Toaster position="bottom-right" richColors closeButton />
        </div>
      </AuthProvider>
    </I18nProvider>
  );
}
